export function getNavRouteFlags(pathname = '') {
  const isLandingRoute = pathname === '/';
  const isInHubRoute = pathname === '/hub' || pathname.startsWith('/hub/');
  const isRestrictedScreen =
    pathname.startsWith('/admin/product/') ||
    pathname.startsWith('/admin/category/') ||
    pathname.startsWith('/admin/coupon/') ||
    pathname.startsWith('/admin/hub/games/') ||
    pathname.startsWith('/product/') ||
    pathname.startsWith('/cart') ||
    pathname.startsWith('/shipping') ||
    pathname.startsWith('/payment') ||
    pathname.startsWith('/placeorder') ||
    pathname.startsWith('/order');

  const isInShopRoute =
    pathname === '/shop' ||
    pathname.startsWith('/shop/') ||
    pathname.startsWith('/account') ||
    pathname.startsWith('/product/') ||
    pathname.startsWith('/cart') ||
    pathname.startsWith('/shipping') ||
    pathname.startsWith('/payment') ||
    pathname.startsWith('/placeorder') ||
    pathname.startsWith('/order');

  return {
    isLandingRoute,
    isInHubRoute,
    isInShopRoute,
    isRestrictedScreen,
  };
}
